import React from "react";
import { useOutletContext } from "react-router-dom";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import useCampaign from "src/hooks/useCampaign";
import useCampaignGroup from "src/hooks/useCampaignGroup";

const SourceType = [
  {
    label: "Referral",
    value: "REFERRAL",
  },
  {
    label: "Campign",
    value: "CAMPIGN",
  },
]

const Source = () => {
  const [{ formikProps }]: any = useOutletContext();

  const { values, setFieldValue, handleBlur, isSubmitting } = formikProps;

  const { Campaign, isDataLoading: isCampaignLoading } = useCampaign();
  const { CampaignGroup, isDataLoading: isCampaignGroupLoading } = useCampaignGroup();

  const CampaignGroupOption = CampaignGroup?.map((el: any) => {
    return {
      label: el?.campaignGroupName,
      value: el?._id,
    };
  });

  const CampaignNameOption = Campaign?.map((el: any) => {
    return {
      label: el?.campaignName,
      value: el?._id,
    };
  });

  return (
    <div className="">
      <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4" >
        {/* Source */}
        <div>
          <ATMSelectValue
            name='source_type'
            value={values.source_type}
            onChange={(newValue) => {
              setFieldValue('source_type', newValue)
              setFieldValue('referral_name', '')
              setFieldValue('campign_name', '')
              setFieldValue('campign_group', '')
            }}
            onBlur={handleBlur}
            label='Source'
            placeholder='Select Source'
            options={SourceType}

          />
        </div>
        {values?.source_type === 'REFERRAL' && <>
          {/* Referral Name */}
          <div className=''>
            <ATMTextField
              name='referral_name'
              value={values.referral_name}
              onChange={(e) => setFieldValue('referral_name', e.target.value)}
              label='Referral Name'
              placeholder='Enter Referral Name'
              onBlur={handleBlur}
            />
          </div>
        </>}

        {values?.source_type === 'CAMPIGN' && <>

          {/* Campign Group */}
          <div>
            <ATMSelectValue
              name='campign_group'
              value={values.campign_group}
              onChange={(newValue) => setFieldValue('campign_group', newValue)}
              onBlur={handleBlur}
              label='Campign Group'
              placeholder='Select Campign Group'
              options={CampaignGroupOption}
              isLoading={isCampaignGroupLoading}

            />
          </div>
          {/* Campign Name */}
          <div>
            <ATMSelectValue
              name='campign_name'
              value={values.campign_name}
              onChange={(newValue) => setFieldValue('campign_name', newValue)}
              onBlur={handleBlur}
              label='Campign Name'
              placeholder='Select Campign Name'
              options={CampaignNameOption}
              isLoading={isCampaignLoading}

            />
          </div>

        </>}
      </div>

      <div className="flex justify-end">
        <ATMLoadingButton
          className="flex justify-end w-[70px] px-5"
          isLoading={isSubmitting}
          type="submit"
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default Source;
